const TZ_DEFAULT = 'America/New_York';

export function fmtDateTime(v: string | Date | null | undefined, tz = TZ_DEFAULT): string {
  if (!v) return '—';
  const d = new Date(v);
  return d.toLocaleString('en-US', { timeZone: tz, month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', weekday: 'short' });
}

/** Records-style stamp: 10/07/26 14:05 (24-hour), as on a printed report. */
export function fmtStamp(v: string | Date | null | undefined, tz = TZ_DEFAULT): string {
  if (!v) return '—';
  const p = new Intl.DateTimeFormat('en-US', { timeZone: tz, month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(v));
  const g = (t: string) => p.find((x) => x.type === t)?.value ?? '';
  return `${g('month')}/${g('day')}/${g('year')} ${g('hour')}:${g('minute')}`;
}

export function fmtDate(v: string | null | undefined): string {
  if (!v) return '—';
  const [y, m, d] = v.slice(0, 10).split('-').map(Number);
  return new Date(Date.UTC(y!, m! - 1, d!)).toLocaleDateString('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
}

export const money = (cents: number | null | undefined) => (cents == null ? '—' : `$${(cents / 100).toFixed(2)}`);

export const titleCase = (s: string) => s.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const newId = () => crypto.randomUUID();
